export default "__VITE_PUBLIC_ASSET__80660462__"